import React, { useState, useEffect } from 'react';
import DirectChat from '../DirectChat/DirectChat';

const SPLASH_DURATION = 2200;

export default function LendingKart({ darkMode, toggleDarkMode }) {
  const [showSplash, setShowSplash] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), SPLASH_DURATION - 400);
    const hideTimer = setTimeout(() => setShowSplash(false), SPLASH_DURATION);
    return () => { clearTimeout(fadeTimer); clearTimeout(hideTimer); };
  }, []);

  if (showSplash) {
    return (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: '#F57C20',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'opacity 0.4s ease',
        opacity: fadeOut ? 0 : 1,
      }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            fontSize: 52, fontWeight: 800, color: '#fff',
            letterSpacing: '-0.03em', lineHeight: 1,
            margin: 0,
          }}>
            Lending Kart
          </h1>
          <p style={{
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            fontSize: 16, fontWeight: 500, color: 'rgba(255,255,255,0.8)',
            letterSpacing: '0.02em',
            marginTop: 10,
          }}>
            Credit Card Expert
          </p>
        </div>
      </div>
    );
  }

  return <DirectChat slug="karan" darkMode={darkMode} toggleDarkMode={toggleDarkMode} themeClass="theme-orange" />;
}
